import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NGXLogger } from 'ngx-logger';

import { AuthenticationService } from '@/auth/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
    constructor(
        private router: Router,
        private logger: NGXLogger,
        private authenticationService: AuthenticationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser && currentUser.loggedIn) {
            // authorised so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        const returnUrl = state.url === '/not-found' ? '' : state.url;
        this.logger.debug('return URL: ' + returnUrl);
        this.router.navigate(['/login'], { queryParams: { returnUrl } });
        return false;
    }
}
